// extracted by mini-css-extract-plugin
export default {"title":"GanttChartMobileRow_title__iLXEE","icon":"GanttChartMobileRow_icon__hLcfm","text":"GanttChartMobileRow_text__-xf54"};